import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import styles from './banner.module.scss';

const Banner = ({ header, image }) => {
  return (
    <Container
      className={styles['aboutus-banner-container']}
      sx={{ backgroundColor: 'secondaryBackground.bgBody' }}
    >
      <Grid container className={styles['aboutus-banner-content-grid']}>
        <Grid item xs={12}>
          <Grid container md={12} lg={12} xl={12}>
            <Grid item md={12} lg={12} xl={12}>
              <Box
                component='img'
                src={image}
                className={styles['aboutus-banner-image']}
                md={12}
                lg={12}
                xl={12}
                sx={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5}>
          <Grid container justifyContent='flex-start'>
            <Grid item alignItems='center'>
              <Typography
                variant='bannerTitlePs'
                component='h1'
                className={styles['aboutus-banner-header']}
                sx={{ backgroundColor: 'common.light' }}
              >
                {header}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Banner;
